import axios, { AxiosRequestConfig } from 'axios'
import aspida from '@aspida/axios'

import api from '../../api/$api'
import {
  GetSpecialOfferResponse,
  SpecialOfferEntity,
  UpdateSpecialOfferDto,
} from '../../api/@types'
import { GetSpecialOfferQuery, ISpecialOffer } from '@/types/special-offer'

export const getSpecialOffers = async (
  query: GetSpecialOfferQuery | null,
): Promise<ISpecialOffer[]> => {
  const config: AxiosRequestConfig = {
    params: {},
  }

  if (query) {
    config.params = {
      ...config.params,
      ...query,
    }
  }
  const instance = axios.create(config)

  try {
    const { data } = await instance.get<ISpecialOffer[]>('special-offers')
    return data
  } catch {
    throw new Error('error.special-offers.getSpecialOffers')
  }
}

export const getSpecialOffer = async (
  id: string,
): Promise<GetSpecialOfferResponse> => {
  const client = api(aspida())

  try {
    const data = await client.special_offers._id(id).$get()
    return data
  } catch {
    throw new Error('error.special-offers.getSpecialOffer')
  }
}

export const updateSpecialOffer = async (
  id: string,
  body: UpdateSpecialOfferDto,
): Promise<SpecialOfferEntity> => {
  const instance = api(aspida())

  const data = await instance.special_offers._id(id).$put({ body })
  return data
}
